import fetchCheckRoom from "../api/fetch-check-room";
import { useAuth } from "../context/AuthContext";

export default function useFetchCheckRoom() {
  const authCtx = useAuth();
  return authCtx.user
    ? (roomId: string) =>
        authCtx.getIdToken().then((token) => fetchCheckRoom(token, roomId))
    : () => Promise.reject("Not authorized");
}
